import { CART_PRODUCT_TYPES } from "../../constants/index.js";
var LOYALTY = CART_PRODUCT_TYPES.LOYALTY,
  RULE = CART_PRODUCT_TYPES.RULE,
  COUPON = CART_PRODUCT_TYPES.COUPON;
export var isLoyaltyLineItem = function isLoyaltyLineItem(p) {
  return p.type === LOYALTY;
};
export var isRuleLineItem = function isRuleLineItem(p) {
  return p.type === RULE;
}; // && p.category === RULE;

export var isCouponLineItem = function isCouponLineItem(p) {
  return p.type === RULE && p.category === COUPON;
}; // && p.category === RULE;

export var getProductLabel = function getProductLabel(_ref) {
  var _product$additionalDa, _product$additionalDa2;
  var type = _ref.type,
    product = _ref.product;
  if (type === CART_PRODUCT_TYPES.HOTEL) {
    var _product$options, _product$options2;
    return {
      key: 'Payment.Sale.PaymentDetails.RoomsNights',
      data: {
        roomsCount: product === null || product === void 0 ? void 0 : (_product$options = product.options) === null || _product$options === void 0 ? void 0 : _product$options.numberOfRooms,
        nightCount: product === null || product === void 0 ? void 0 : (_product$options2 = product.options) === null || _product$options2 === void 0 ? void 0 : _product$options2.numberOfNights
      }
    };
  }
  if (product !== null && product !== void 0 && (_product$additionalDa = product.additionalData) !== null && _product$additionalDa !== void 0 && (_product$additionalDa2 = _product$additionalDa._pricingRules) !== null && _product$additionalDa2 !== void 0 && _product$additionalDa2.name) {
    var _product$additionalDa3, _product$additionalDa4;
    return product === null || product === void 0 ? void 0 : (_product$additionalDa3 = product.additionalData) === null || _product$additionalDa3 === void 0 ? void 0 : (_product$additionalDa4 = _product$additionalDa3._pricingRules) === null || _product$additionalDa4 === void 0 ? void 0 : _product$additionalDa4.name;
  }
  return type;
};
export var getProductTitle = function getProductTitle(_ref2) {
  var _product$additionalDa5, _product$additionalDa6;
  var cartType = _ref2.cartType,
    product = _ref2.product;
  switch (cartType) {
    case CART_PRODUCT_TYPES.HOTEL:
      return 'Payment.Sale.PaymentDetails.HotelBreakdown';
    case CART_PRODUCT_TYPES.FLIGHT:
      return 'Payment.Sale.PaymentDetails.FlightFareBreakdown';
    case CART_PRODUCT_TYPES.ACTIVITIES:
      return 'Payment.Sale.PaymentDetails.PriceBreakdown';
  }
  if (product !== null && product !== void 0 && (_product$additionalDa5 = product.additionalData) !== null && _product$additionalDa5 !== void 0 && (_product$additionalDa6 = _product$additionalDa5._pricingRules) !== null && _product$additionalDa6 !== void 0 && _product$additionalDa6.name) {
    var _product$additionalDa7, _product$additionalDa8;
    return product === null || product === void 0 ? void 0 : (_product$additionalDa7 = product.additionalData) === null || _product$additionalDa7 === void 0 ? void 0 : (_product$additionalDa8 = _product$additionalDa7._pricingRules) === null || _product$additionalDa8 === void 0 ? void 0 : _product$additionalDa8.name;
  }
  return cartType;
};